module.exports = __webpack_public_path__ + "img/8_003.e97071a9.webp";